var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 338,
    viewBox: "0 0 1440 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.415 346.301L602.273 326.285V263.537L584.415 243.521V346.301Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 266.133H601.13V267.883H597.393V266.133Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 270.941H601.13V272.691H597.393V270.941Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 275.75H601.13V277.5H597.393V275.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 280.557H601.13V282.307H597.393V280.557Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 285.365H601.13V287.115H597.393V285.365Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 290.172H601.13V291.922H597.393V290.172Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 294.98H601.13V296.73H597.393V294.98Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 299.789H601.13V301.539H597.393V299.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 304.596H601.13V306.346H597.393V304.596Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 309.404H601.13V311.154H597.393V309.404Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 314.211H601.13V315.961H597.393V314.211Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 319.02H601.13V320.77H597.393V319.02Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.393 323.828H601.13V325.578H597.393V323.828Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.453 346.301L555.595 326.285V263.537L573.453 243.521V346.301Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 266.133H560.476V267.883H556.739V266.133Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 270.941H560.476V272.691H556.739V270.941Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 275.75H560.476V277.5H556.739V275.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 280.557H560.476V282.307H556.739V280.557Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 285.365H560.476V287.115H556.739V285.365Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 290.172H560.476V291.922H556.739V290.172Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 294.98H560.476V296.73H556.739V294.98Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 299.789H560.476V301.539H556.739V299.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 304.596H560.476V306.346H556.739V304.596Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 309.404H560.476V311.154H556.739V309.404Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 314.211H560.476V315.961H556.739V314.211Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 319.02H560.476V320.77H556.739V319.02Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 323.828H560.476V325.578H556.739V323.828Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.934 227.537L587.894 234.434H569.975L578.934 227.537Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.975 234.434H587.894V239.786H569.975V234.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.975 239.786H587.894L594.654 244.933H563.215L569.975 239.786Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.457 244.933H596.414V337.674H561.457V244.933Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 247.712H594.654V254.506H563.215V247.712Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 256.049H594.654V265.108H563.215V256.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 266.412H594.654V275.471H563.215V266.412Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 276.775H594.654V285.834H563.215V276.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 287.139H594.654V296.198H563.215V287.139Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 297.502H594.654V306.561H563.215V297.502Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 307.865H594.654V316.924H563.215V307.865Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 318.229H594.654V327.288H563.215V318.229Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.215 328.592H594.654V337.651H563.215V328.592Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.678 325.115L578.934 337.674L586.19 325.115V266.133L578.934 254.506L571.678 266.133V325.115Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 323.828H583.822V325.578H574.048V323.828Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 319.02H583.822V320.77H574.048V319.02Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 314.213H583.822V315.963H574.048V314.213Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 309.404H583.822V311.154H574.048V309.404Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 304.598H583.822V306.348H574.048V304.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 299.789H583.822V301.539H574.048V299.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 294.982H583.822V296.732H574.048V294.982Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 290.174H583.822V291.924H574.048V290.174Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 285.367H583.822V287.117H574.048V285.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 280.559H583.822V282.309H574.048V280.559Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 275.752H583.822V277.502H574.048V275.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 270.943H583.822V272.693H574.048V270.943Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.048 266.137H583.822V267.887H574.048V266.137Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.457 337.674H596.414V359.496H561.457V337.674Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.535 311.234H557.909V359.496H542.535V311.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 325.455H547.638V327.252H545.32V325.455Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 325.455H551.38V327.252H549.062V325.455Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 325.455H555.122V327.252H552.805V325.455Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 321.598H547.638V323.395H545.32V321.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 321.598H551.38V323.395H549.062V321.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 321.598H555.122V323.395H552.805V321.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 317.74H547.638V319.537H545.32V317.74Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 317.74H551.38V319.537H549.062V317.74Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 317.74H555.122V319.537H552.805V317.74Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 313.883H547.638V315.68H545.32V313.883Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 313.883H551.38V315.68H549.062V313.883Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 313.883H555.122V315.68H552.805V313.883Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 337.027H547.638V338.824H545.32V337.027Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 337.027H551.38V338.824H549.062V337.027Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 337.027H555.122V338.824H552.805V337.027Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 333.17H547.638V334.967H545.32V333.17Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 333.17H551.38V334.967H549.062V333.17Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 333.17H555.122V334.967H552.805V333.17Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 329.313H547.638V331.11H545.32V329.313Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 329.313H551.38V331.11H549.062V329.313Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.805 329.313H555.122V331.11H552.805V329.313Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.021 269.328H212.64V359.496H161.021V269.328Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.951 79.337H187.711V103.859H185.951V79.337Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75 102.211H189.912V116.636H183.75V102.211Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.718 124.569C176.941 119.845 180.401 115.426 185.446 114.698C190.491 113.971 195.211 117.211 195.988 121.935C196.765 126.659 193.305 131.078 188.26 131.806C183.215 132.533 178.495 129.293 177.718 124.569Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.871 133.697C173.8 127.518 178.281 121.696 184.88 120.693C191.479 119.69 197.697 123.886 198.768 130.065C199.839 136.244 195.357 142.066 188.758 143.069C182.159 144.072 175.941 139.876 174.871 133.697Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.831 152.781C178.974 152.781 172.604 146.817 172.604 139.46C172.604 132.103 178.974 126.139 186.831 126.139C194.688 126.139 201.058 132.103 201.058 139.46C201.058 146.817 194.688 152.781 186.831 152.781Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.434 174.231C170.434 182.515 177.607 189.231 186.454 189.231H187.206C196.053 189.231 203.226 182.515 203.226 174.231V149.004C203.226 140.72 196.053 134.004 187.206 134.004H186.454C177.607 134.004 170.434 140.72 170.434 149.004V174.231Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.984 144.25H193.524V186.082H191.984V144.25Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06 144.25H187.6V186.082H186.06V144.25Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.137 144.25H181.677V186.082H180.137V144.25Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.204 169.494H208.458V269.328H165.204V169.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.789 182.494V169.494H201.871V182.494H208.458V269.328H165.204V182.494H171.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.202 277.328H216.824V358.662H199.202V277.328Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.202 289.994H222.519V359.496H199.202V289.994Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.838 277.328H174.46V358.662H156.838V277.328Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.143 289.994H174.46V359.496H151.143V289.994Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.822 314.41H174.46V346.256H199.202V314.41H211.839H228.75V359.496H211.839H161.822H144.912V314.41H161.822Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.251 321.285H222.09V322.285H217.251V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.251 325.785H222.09V326.785H217.251V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.251 330.285H222.09V331.285H217.251V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.251 334.785H222.09V335.785H217.251V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 321.285H211.287V322.285H206.448V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 325.785H211.287V326.785H206.448V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 330.285H211.287V331.285H206.448V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 334.785H211.287V335.785H206.448V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.374 321.285H167.213V322.285H162.374V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.374 325.785H167.213V326.785H162.374V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.374 330.285H167.213V331.285H162.374V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.374 334.785H167.213V335.785H162.374V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57 321.285H156.409V322.285H151.57V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57 325.785H156.409V326.785H151.57V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57 330.285H156.409V331.285H151.57V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57 334.785H156.409V335.785H151.57V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.415 297.16H216.483V299.91H215.415V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.753 297.16H211.821V299.91H210.753V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.091 297.16H207.159V299.91H206.091V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.415 305.16H216.483V307.91H215.415V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.753 305.16H211.821V307.91H210.753V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.091 305.16H207.159V307.91H206.091V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.357 297.16H168.425V299.91H167.357V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.695 297.16H163.763V299.91H162.695V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.034 297.16H159.102V299.91H158.034V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.357 305.16H168.425V307.91H167.357V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.695 305.16H163.763V307.91H162.695V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.034 305.16H159.102V307.91H158.034V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 186.786H203.654V187.661H198.461V186.786Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 191.223H203.654V192.098H198.461V191.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 195.661H203.654V196.536H198.461V195.661Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 200.098H203.654V200.973H198.461V200.098Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 204.536H203.654V205.411H198.461V204.536Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 208.973H203.654V209.848H198.461V208.973Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 213.411H203.654V214.286H198.461V213.411Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 217.848H203.654V218.723H198.461V217.848Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 222.286H203.654V223.161H198.461V222.286Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 226.723H203.654V227.598H198.461V226.723Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 231.161H203.654V232.036H198.461V231.161Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 235.598H203.654V236.473H198.461V235.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 240.036H203.654V240.911H198.461V240.036Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 244.473H203.654V245.348H198.461V244.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 248.91H203.654V249.785H198.461V248.91Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 253.348H203.654V254.223H198.461V253.348Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 257.785H203.654V258.66H198.461V257.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.461 262.223H203.654V263.098H198.461V262.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 186.786H176.055V187.661H170.862V186.786Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 191.223H176.055V192.098H170.862V191.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 195.661H176.055V196.536H170.862V195.661Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 200.098H176.055V200.973H170.862V200.098Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 204.536H176.055V205.411H170.862V204.536Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 208.973H176.055V209.848H170.862V208.973Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 213.411H176.055V214.286H170.862V213.411Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 217.848H176.055V218.723H170.862V217.848Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 222.286H176.055V223.161H170.862V222.286Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 226.723H176.055V227.598H170.862V226.723Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 231.161H176.055V232.036H170.862V231.161Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 235.598H176.055V236.473H170.862V235.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 240.036H176.055V240.911H170.862V240.036Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 244.473H176.055V245.348H170.862V244.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 248.91H176.055V249.785H170.862V248.91Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 253.348H176.055V254.223H170.862V253.348Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 257.785H176.055V258.66H170.862V257.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.862 262.223H176.055V263.098H170.862V262.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.381 175.911H193.151V346.256H192.381V175.911Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.445 175.911H187.215V346.256H186.445V175.911Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.51 175.911H181.28V346.256H180.51V175.911Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.613 328.639V345.244H105.936V328.639H113.481V359.496H70.0686V328.639H77.613Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0754 314.635H79.0024V330.992H69.0754V314.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.876 314.635H114.803V330.992H104.876V314.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.968 287H23.9108C23.9108 287 49.5855 320.832 91.9381 320.832C134.291 320.832 159.968 287 159.968 287Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7251 321.93H76.0676V323.615H71.7251V321.93Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7251 324.508H76.0676V326.196H71.7251V324.508Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7251 327.088H76.0676V328.773H71.7251V327.088Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.374 321.93H111.716V323.615H107.374V321.93Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.374 324.508H111.716V326.196H107.374V324.508Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.374 327.088H111.716V328.773H107.374V327.088Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.85 287V300.758",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.468 306.897V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.112 311.703V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.977 315.338V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.887 318V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.915 319.904V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7324 320.693V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6892 320.756V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5542 320.008V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5068 318.471V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4253 315.91V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1482 312.391V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1008 307.961V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.793 302.242V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9197 287V295.592",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0534 305.594C59.0534 305.594 74.2724 312.469 91.0272 312.469C109.779 312.469 123.001 305.594 123.001 305.594V290.344H59.0545V305.594H59.0534Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9064 291.469H80.0449V294.219H75.9064V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5258 291.469H95.6643V294.219H91.5258V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6999 291.469H74.8384V294.219H70.6999V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8384 309.502C73.3784 309.187 71.9911 308.854 70.6999 308.514V307.594H74.8384V309.502Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.113 291.469H85.2515V294.219H81.113V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6318 308.227C68.8565 308.014 68.1238 307.803 67.4296 307.594H69.6318V308.227Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4933 291.469H69.6318V294.219H65.4933V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3193 291.469H90.4578V294.219H86.3193V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4545 299.344H64.4253V302.469H60.4545V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.352 303.469H116.49V306.594H112.352V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4545 291.469H64.4253V294.219H60.4545V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4253 306.594H64.3003C61.8696 305.768 60.4545 305.168 60.4545 305.168V303.469H64.4253V306.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.352 299.344H116.49V302.469H112.352V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.559 295.219H121.599V298.344H117.559V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.145 291.469H111.284V294.219H107.145V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.559 291.469H121.599V294.219H117.559V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.352 291.469H116.49V294.219H112.352V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7323 291.469H100.871V294.219H96.7323V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.939 291.469H106.077V294.219H101.939V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.559 299.344H121.599V302.469H117.559V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.077 309.908C104.763 310.158 103.383 310.388 101.939 310.588V307.594H106.077V309.908Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.284 308.732C110.003 309.066 108.622 309.392 107.145 309.695V307.593H111.284V308.732Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.352 308.445V307.593H115.223C114.345 307.873 113.387 308.16 112.352 308.445Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2515 310.719H81.8456C81.601 310.686 81.3554 310.655 81.113 310.619V307.594H85.2515V310.719Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.599 305.168C121.599 305.168 120.37 305.768 118.137 306.594H117.559V303.469H121.599V305.168Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0449 310.463C78.6181 310.244 77.2339 309.994 75.9064 309.725V307.594H80.0449V310.463Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3193 303.469H90.4578V306.594H86.3193V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9064 303.469H80.0449V306.594H75.9064V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.113 299.344H85.2515V302.469H81.113V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9064 299.344H80.0449V302.469H75.9064V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.113 295.219H85.2515V298.344H81.113V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.113 303.469H85.2515V306.594H81.113V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3193 299.344H90.4578V302.469H86.3193V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3193 295.219H90.4578V298.344H86.3193V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9064 295.219H80.0449V298.344H75.9064V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4933 295.219H69.6318V298.344H65.4933V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4545 295.219H64.4253V298.344H60.4545V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4933 299.344H69.6318V302.469H65.4933V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4933 303.469H69.6318V306.594H65.4933V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6999 303.469H74.8384V306.594H70.6999V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6999 299.344H74.8384V302.469H70.6999V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6999 295.219H74.8384V298.344H70.6999V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5258 299.344H95.6643V302.469H91.5258V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.939 299.344H106.077V302.469H101.939V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.939 303.469H106.077V306.594H101.939V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.145 295.219H111.284V298.344H107.145V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.939 295.219H106.077V298.344H101.939V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.145 303.469H111.284V306.594H107.145V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3193 307.594H90.4578V310.719H86.3193V307.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.145 299.344H111.284V302.469H107.145V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7323 307.594H100.871V310.719H96.7323V307.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7323 303.469H100.871V306.594H96.7323V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.352 295.219H116.49V298.344H112.352V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5258 295.219H95.6643V298.344H91.5258V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5258 303.469H95.6643V306.594H91.5258V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5258 307.594H95.6643V310.719H91.5258V307.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7323 295.219H100.871V298.344H96.7323V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7323 299.344H100.871V302.469H96.7323V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.166 336.51H133.807V359.496H147.819L140.166 336.51Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.652 338.094H133.807V343.844H140.121L138.652 338.094Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.376 336.51H49.7349V359.496H35.7227L43.376 336.51Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8883 338.094H49.7349V343.844H43.4198L44.8883 338.094Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.517 297.468H329.451V303.403H226.517V297.468Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.118 315.685H330.871V359.497H325.118V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.741 317.041C324.741 317.317 324.982 317.543 325.277 317.543H330.713C331.009 317.543 331.248 317.317 331.248 317.041C331.248 316.766 331.009 316.539 330.713 316.539H325.277C324.981 316.539 324.741 316.766 324.741 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.078 316.279C324.078 316.699 324.444 317.041 324.893 317.041H331.096C331.545 317.041 331.909 316.699 331.909 316.279C331.909 315.859 331.545 315.517 331.096 315.517H324.893C324.444 315.518 324.078 315.859 324.078 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.217 318.487H329.685V356.095H329.217V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.76 318.487H328.228V356.095H327.76V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.305 318.487H326.772V356.095H326.305V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.113 315.685H310.866V359.497H305.113V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.737 317.041C304.737 317.317 304.976 317.543 305.272 317.543H310.708C311.004 317.543 311.244 317.317 311.244 317.041C311.244 316.766 311.004 316.539 310.708 316.539H305.272C304.976 316.539 304.737 316.766 304.737 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.076 316.279C304.076 316.699 304.44 317.041 304.889 317.041H311.092C311.541 317.041 311.906 316.699 311.906 316.279C311.906 315.859 311.541 315.517 311.092 315.517H304.889C304.44 315.518 304.076 315.859 304.076 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.213 318.487H309.68V356.095H309.213V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.756 318.487H308.224V356.095H307.756V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.299 318.487H306.768V356.095H306.299V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.108 315.685H290.863V359.497H285.108V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 317.041C284.732 317.317 284.973 317.543 285.268 317.543H290.705C290.999 317.543 291.241 317.317 291.241 317.041C291.241 316.766 290.999 316.539 290.705 316.539H285.268C284.972 316.539 284.732 316.766 284.732 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.072 316.279C284.072 316.699 284.435 317.041 284.886 317.041H291.089C291.538 317.041 291.903 316.699 291.903 316.279C291.903 315.859 291.538 315.517 291.089 315.517H284.886C284.434 315.518 284.072 315.859 284.072 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.208 318.487H289.676V356.095H289.208V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.75 318.487H288.218V356.095H287.75V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.297 318.487H286.764V356.095H286.297V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.105 315.685H270.858V359.497H265.105V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.728 317.041C264.728 317.317 264.967 317.543 265.264 317.543H270.699C270.994 317.543 271.235 317.317 271.235 317.041C271.235 316.766 270.994 316.539 270.699 316.539H265.264C264.967 316.539 264.728 316.766 264.728 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.067 316.279C264.067 316.699 264.431 317.041 264.88 317.041H271.083C271.532 317.041 271.897 316.699 271.897 316.279C271.897 315.859 271.532 315.517 271.083 315.517H264.88C264.431 315.518 264.067 315.859 264.067 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.203 318.487H269.67V356.095H269.203V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.748 318.487H268.216V356.095H267.748V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.292 318.487H266.76V356.095H266.292V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.099 315.685H250.853V359.497H245.099V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.724 317.041C244.724 317.317 244.964 317.543 245.26 317.543H250.695C250.991 317.543 251.231 317.317 251.231 317.041C251.231 316.766 250.991 316.539 250.695 316.539H245.26C244.963 316.539 244.724 316.766 244.724 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.063 316.279C244.063 316.699 244.427 317.041 244.877 317.041H251.08C251.528 317.041 251.893 316.699 251.893 316.279C251.893 315.859 251.528 315.517 251.08 315.517H244.877C244.426 315.518 244.063 315.859 244.063 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2 318.487H249.668V356.095H249.2V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.742 318.487H248.21V356.095H247.742V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.288 318.487H246.754V356.095H246.288V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.095 315.685H230.847V359.497H225.095V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.718 317.041C224.718 317.317 224.959 317.543 225.254 317.543H230.689C230.985 317.543 231.226 317.317 231.226 317.041C231.226 316.766 230.985 316.539 230.689 316.539H225.254C224.959 316.539 224.718 316.766 224.718 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.057 316.279C224.057 316.699 224.421 317.041 224.871 317.041H231.074C231.523 317.041 231.888 316.699 231.888 316.279C231.888 315.859 231.523 315.517 231.074 315.517H224.871C224.421 315.518 224.057 315.859 224.057 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.193 318.487H229.661V356.095H229.193V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.739 318.487H228.206V356.095H227.739V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.283 318.487H226.751V356.095H226.283V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.028 308.269H330.937V313.426H225.028V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.828 308.269H330.937V313.426H327.828V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.028 308.269H228.138V313.426H225.028V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23 308.269H323.62V313.426H321.23V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.887 308.269H317.276V313.426H314.887V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.545 308.269H310.935V313.426H308.545V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.201 308.269H304.591V313.426H302.201V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.859 308.269H298.248V313.426H295.859V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.516 308.269H291.905V313.426H289.516V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.171 308.269H285.56V313.426H283.171V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.829 308.269H279.218V313.426H276.829V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.486 308.269H272.875V313.426H270.486V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.143 308.269H266.532V313.426H264.143V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.801 308.269H260.19V313.426H257.801V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.459 308.269H253.848V313.426H251.459V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.115 308.269H247.504V313.426H245.115V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.771 308.269H241.16V313.426H238.771V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.428 308.269H234.817V313.426H232.428V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.982 313.426H330.982V315.518H224.982V313.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.169 306.01H334.798V308.849H221.169V306.01Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.296 304.652H336.669L334.798 306.01H221.169L219.296 304.652Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.851 303.403H331.116V304.652H224.851V303.403Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.539 295.326H333.428V297.468H222.539V295.326Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.863 293.673H293.104V295.326H262.863V293.673Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.992 295.326H294.976V297.468H260.992V295.326Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.846 298.44H300.12V298.831H255.846V298.44Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.611 299.674H303.354V300.063H252.611V299.674Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.954 300.906H311.013V301.295H244.954V300.906Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.016 302.139H315.951V302.528H240.016V302.139Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.031 297.468H292.937V304.652H263.031V297.468Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.105 298.125H290.863V303.403H265.105V298.125Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.892 284.075C265.906 284.031 266.697 284.316 267.098 285.177C267.22 285.44 267.367 285.701 267.436 285.978C267.68 286.947 268.209 287.553 269.376 287.44C269.492 287.43 269.617 287.481 269.738 287.507C270.438 287.656 270.792 287.99 270.779 288.659C270.769 289.082 270.665 289.531 270.472 289.914C270.197 290.465 269.917 290.982 270.19 291.601C270.53 292.372 270.361 293.016 269.65 293.53C269.637 293.538 269.664 293.594 269.678 293.641C270.279 293.641 270.885 293.641 271.533 293.641C271.608 291.586 271.683 289.561 271.754 287.565C272.095 287.469 272.458 287.463 272.645 287.29C272.855 287.095 272.998 286.755 273.014 286.469C273.039 286.011 272.936 285.546 272.882 285.083C272.733 283.81 272.842 283.673 274.182 283.499C274.235 282.824 274.261 282.135 274.355 281.454C274.396 281.145 274.493 280.79 274.701 280.569C274.917 280.342 275.299 280.139 275.611 280.135C276.029 280.132 276.076 280.516 276.107 280.867C276.12 280.998 276.368 281.11 276.512 281.231C276.611 281.048 276.783 280.869 276.787 280.685C276.791 280.519 276.606 280.351 276.508 280.183C276.201 279.651 276.339 279.398 276.987 279.357C277.384 279.332 277.787 279.351 278.2 279.351C278.274 278.632 278.402 278.049 277.415 277.656C276.249 277.191 276.32 275.808 277.415 275.148C277.586 275.045 277.761 274.949 278.026 274.794C276.743 274.568 276.232 273.628 275.509 272.934C275.394 272.826 275.356 272.62 275.345 272.455C275.323 272.154 275.501 272.004 275.806 272.148C276.598 272.523 277.377 272.923 278.024 273.245C278.145 273.101 278.298 272.734 278.521 272.689C279.103 272.573 279.035 273.05 279.032 273.252C279.719 272.907 280.436 272.536 281.167 272.195C281.323 272.123 281.538 272.161 281.726 272.147C281.733 272.33 281.761 272.513 281.741 272.693C281.727 272.798 281.659 272.921 281.575 272.994C280.855 273.607 280.405 274.527 279.321 274.726C279.289 274.732 279.271 274.816 279.229 274.892C280.009 275.22 280.645 275.674 280.558 276.558C280.47 277.433 279.763 277.79 278.946 278.019C278.946 278.57 278.925 279.107 278.953 279.639C278.973 279.984 279.152 280.114 279.573 280.027C280.298 279.879 280.754 280.2 280.742 280.89C280.728 281.782 280.612 282.671 280.53 283.56C280.483 284.075 280.396 284.585 280.374 285.101C280.366 285.261 280.468 285.478 280.598 285.578C280.953 285.851 281.352 286.074 281.878 286.406C281.766 285.926 281.677 285.582 281.612 285.235C281.496 284.619 281.851 284.072 282.399 283.995C282.919 283.922 283.429 284.318 283.54 284.9C283.575 285.088 283.533 285.286 283.568 285.474C283.733 286.378 283.647 287.327 284.393 288.111C284.654 288.387 284.683 288.933 284.663 289.348C284.639 289.777 284.396 290.19 284.307 290.62C284.103 291.609 283.935 292.603 283.747 293.634C284.698 293.634 285.542 293.634 286.484 293.634C286.283 293.432 286.099 293.314 286.025 293.154C285.874 292.823 285.609 292.419 285.701 292.13C285.99 291.222 285.941 290.405 285.35 289.628C285.293 289.551 285.264 289.454 285.234 289.362C284.93 288.405 285.341 287.53 286.326 287.51C287.81 287.479 288.393 286.716 288.707 285.547C288.762 285.345 288.87 285.154 288.97 284.967C289.338 284.291 289.979 283.969 290.785 284.049C290.966 284.066 291.146 284.115 291.325 284.115C291.731 284.108 291.78 284.26 291.714 284.617C291.61 285.176 291.543 285.755 291.576 286.318C291.625 287.168 291.409 287.424 290.419 287.374C290.98 288.032 290.987 288.714 290.717 289.454C290.654 289.626 290.884 289.897 290.995 290.118C291.093 290.313 291.308 290.503 291.304 290.691C291.29 291.36 291.256 292.034 291.116 292.684C291.077 292.873 290.654 292.987 290.409 293.135C290.318 292.891 290.189 292.653 290.155 292.401C290.135 292.278 290.306 292.139 290.37 291.999C290.572 291.556 290.728 291.012 290.24 290.749C289.805 290.517 289.205 290.54 288.675 290.483C288.621 290.479 288.496 290.711 288.476 290.841C288.391 291.406 288.327 291.975 288.271 292.544C288.193 293.301 288.557 293.673 289.364 293.673H266.583C267.492 293.673 267.822 293.322 267.716 292.484C267.655 291.991 267.621 291.496 267.545 291.006C267.519 290.834 267.389 290.53 267.325 290.535C266.796 290.572 266.186 290.539 265.765 290.78C265.278 291.058 265.42 291.623 265.657 292.083C265.692 292.151 265.769 292.213 265.771 292.283C265.79 292.533 265.829 292.795 265.771 293.034C265.752 293.112 265.383 293.22 265.319 293.166C265.125 293.004 264.926 292.784 264.87 292.557C264.752 292.094 264.725 291.612 264.664 291.137C264.609 290.72 264.639 290.352 265.075 290.074C265.222 289.982 265.333 289.664 265.277 289.506C265.018 288.777 264.974 288.088 265.546 287.43C264.488 287.408 264.362 287.247 264.42 286.283C264.45 285.795 264.498 285.267 264.344 284.816C264.14 284.229 264.161 284.105 264.892 284.075ZM282.436 293.641C282.436 292.987 282.436 292.344 282.436 291.703C282.38 291.7 282.325 291.694 282.271 291.692C282.247 292.051 282.245 292.413 282.199 292.77C282.148 293.176 282.095 293.614 281.445 293.463C281.081 292.852 281.752 292.111 281.272 291.516C281.205 291.52 281.136 291.521 281.069 291.524C281.035 292.215 281.001 292.907 280.964 293.641C281.501 293.641 281.941 293.641 282.436 293.641ZM275.727 293.641C277.178 293.641 278.601 293.641 280.089 293.641C280.049 292.987 280.012 292.37 279.974 291.735C278.721 291.735 277.504 291.735 276.313 291.735C276.228 291.985 276.213 292.312 276.085 292.358C275.272 292.648 275.683 293.17 275.727 293.641ZM274.485 293.645C274.567 293.641 274.651 293.635 274.736 293.631C274.697 293.125 274.659 292.621 274.619 292.115C274.576 292.119 274.53 292.121 274.485 292.123C274.485 292.631 274.485 293.139 274.485 293.645Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.212 261.246H481.648L476.402 359.496H493.096L487.212 261.246Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.92 247.549H485.941L484.431 197.382L482.92 247.549Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.535 226.113C480.535 227.182 482.315 228.049 484.51 228.049C486.705 228.049 488.484 227.183 488.484 226.113C488.484 225.043 486.705 224.177 484.51 224.177C482.315 224.177 480.535 225.044 480.535 226.113Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.125 245.465H487.053V253.504H482.125V245.465Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.423 250.379H489.279V254.547H479.423V250.379Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.606 263.031L481.398 265.928H487.493L493.096 263.031V256.332L489.279 253.318H479.422L475.606 256.332V263.031Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.606 257.006H493.096V262.272H475.606V257.006Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.606 259.119H493.096V260.265H475.606V259.119Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.031 208.566H419.493V220.22H406.031V208.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 340.568H429.907V194.058L416.699 208.566V340.568Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 212.134H429.907V215.701H423.302V212.134Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 327.838H429.907V331.404H423.302V327.838Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 215.701H429.907V225.046H423.302V215.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 225.046H429.907V234.391H423.302V225.046Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 234.391H429.907V243.736H423.302V234.391Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 243.735H429.907V253.08H423.302V243.735Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 253.08H429.907V262.424H423.302V253.08Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 262.424H429.907V271.77H423.302V262.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 271.77H429.907V281.116H423.302V271.77Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 281.115H429.907V290.459H423.302V281.115Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 290.459H429.907V299.805H423.302V290.459Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 299.805H429.907V309.149H423.302V299.805Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 309.148H429.907V318.494H423.302V309.148Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.302 318.494H429.907V327.838H423.302V318.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 218.683H416.699V225.046H398.776V218.683Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 225.046H416.699V231.409H398.776V225.046Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 231.409H416.699V237.772H398.776V231.409Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 237.773H416.699V244.136H398.776V237.773Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 244.136H416.699V250.499H398.776V244.136Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 250.499H416.699V256.861H398.776V250.499Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.776 256.861H416.699V266.578H398.776V256.861Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 266.578V278.496L423.302 282.496V332.746H429.907V359.496H423.302H398.775V332.746V266.578H416.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 286.775H417.683V291.375H416.699V286.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 286.775H411.61V291.375H410.625V286.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 286.775H405.536V291.375H404.551V286.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 295.205H417.683V299.805H416.699V295.205Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 295.205H411.61V299.805H410.625V295.205Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 295.205H405.536V299.805H404.551V295.205Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 303.635H417.683V308.235H416.699V303.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 303.635H411.61V308.235H410.625V303.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 303.635H405.536V308.235H404.551V303.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 312.065H417.683V316.665H416.699V312.065Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 312.065H411.61V316.665H410.625V312.065Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 312.065H405.536V316.665H404.551V312.065Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 320.494H417.683V325.094H416.699V320.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 320.494H411.61V325.094H410.625V320.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 320.494H405.536V325.094H404.551V320.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 328.924H417.683V333.524H416.699V328.924Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 328.924H411.61V333.524H410.625V328.924Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 328.924H405.536V333.524H404.551V328.924Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 337.354H417.683V341.954H416.699V337.354Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.625 337.354H411.61V341.954H410.625V337.354Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.551 337.354H405.536V341.954H404.551V337.354Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.854 225.566H517.783V242.344H516.854V225.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.248 251.418H519.388L518.717 239.238H515.796L515.248 251.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.853 251.418H517.783L517.317 239.238L516.853 251.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.125 249.018H526.506V257.36H508.125V249.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.828 253.189L517.43 250.938L529.034 253.189V359.496H505.828V253.189Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.034 348.545L517.43 250.938L505.828 348.545H529.034Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.942 307.586H386.579V359.496H342.942V307.586Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.971 164.292H366.55C366.54 164.67 366.536 165.052 366.536 165.435C366.536 173.23 368.254 180.039 370.813 183.725V184.047H358.709V183.724C361.266 180.037 362.984 173.229 362.984 165.435C362.983 165.052 362.977 164.67 362.971 164.292Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.247 149.839H365.272V164.292H364.247V149.839Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.543 183.111H374.976V189.246H354.543V183.111Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.322 188.206H378.196V192.053H351.322V188.206Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.436 191.534H381.083V192.677H348.436V191.534Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.322 192.677H378.196V359.496H351.322V192.677Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.772 195.284H373.999V198.251H372.772V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 195.284H370.494V198.251H369.268V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 200.75H370.494V203.718H369.268V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 206.217H370.494V209.184H369.268V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 211.684H370.494V214.652H369.268V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 217.15H370.494V220.117H369.268V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 222.617H370.494V225.584H369.268V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 228.084H370.494V231.052H369.268V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 233.55H370.494V236.518H369.268V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 239.018H370.494V241.985H369.268V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 244.484H370.494V247.451H369.268V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 249.951H370.494V252.919H369.268V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 255.418H370.494V258.385H369.268V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 260.885H370.494V263.854H369.268V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 266.352H370.494V269.319H369.268V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 271.817H370.494V274.785H369.268V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 277.285H370.494V280.252H369.268V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 282.752H370.494V285.719H369.268V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 288.219H370.494V291.187H369.268V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 293.685H370.494V296.653H369.268V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 195.284H367.623V198.251H366.396V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 195.284H364.118V198.251H362.892V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 200.75H367.623V203.718H366.396V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 200.75H364.118V203.718H362.892V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 206.217H367.623V209.184H366.396V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 206.217H364.118V209.184H362.892V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 211.684H367.623V214.652H366.396V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 211.684H364.118V214.652H362.892V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 217.15H367.623V220.117H366.396V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 217.15H364.118V220.117H362.892V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 222.617H367.623V225.584H366.396V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 222.617H364.118V225.584H362.892V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 228.084H367.623V231.052H366.396V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 228.084H364.118V231.052H362.892V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 233.55H367.623V236.518H366.396V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 233.55H364.118V236.518H362.892V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 239.018H367.623V241.985H366.396V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 239.018H364.118V241.985H362.892V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 244.484H367.623V247.451H366.396V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 244.484H364.118V247.451H362.892V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 249.951H367.623V252.919H366.396V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 249.951H364.118V252.919H362.892V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 255.418H367.623V258.385H366.396V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 255.418H364.118V258.385H362.892V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 260.885H367.623V263.854H366.396V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 260.885H364.118V263.854H362.892V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 266.352H367.623V269.319H366.396V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 266.352H364.118V269.319H362.892V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 271.817H367.623V274.785H366.396V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 271.817H364.118V274.785H362.892V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 277.285H367.623V280.252H366.396V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 277.285H364.118V280.252H362.892V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 282.752H367.623V285.719H366.396V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 282.752H364.118V285.719H362.892V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 288.219H367.623V291.187H366.396V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 288.219H364.118V291.187H362.892V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 293.685H367.623V296.653H366.396V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 293.685H364.118V296.653H362.892V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 195.284H360.252V198.251H359.025V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.518 195.284H356.747V198.251H355.518V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 200.75H360.252V203.718H359.025V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 206.217H360.252V209.184H359.025V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 211.684H360.252V214.652H359.025V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 217.15H360.252V220.117H359.025V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 222.617H360.252V225.584H359.025V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 228.084H360.252V231.052H359.025V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 233.55H360.252V236.518H359.025V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 239.018H360.252V241.985H359.025V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 244.484H360.252V247.451H359.025V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 249.951H360.252V252.919H359.025V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 255.418H360.252V258.385H359.025V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 260.885H360.252V263.854H359.025V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 266.352H360.252V269.319H359.025V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 271.817H360.252V274.785H359.025V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 277.285H360.252V280.252H359.025V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 282.752H360.252V285.719H359.025V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 288.219H360.252V291.187H359.025V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 293.685H360.252V296.653H359.025V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 299.15H370.494V302.119H369.268V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 304.619H370.494V307.586H369.268V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 310.085H370.494V313.053H369.268V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.268 315.552H370.494V318.52H369.268V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 299.15H367.623V302.119H366.396V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 299.15H364.118V302.119H362.892V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 304.619H367.623V307.586H366.396V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 304.619H364.118V307.586H362.892V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 310.085H367.623V313.053H366.396V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 310.085H364.118V313.053H362.892V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.396 315.552H367.623V318.52H366.396V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.892 315.552H364.118V318.52H362.892V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 299.15H360.252V302.119H359.025V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 304.619H360.252V307.586H359.025V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 310.085H360.252V313.053H359.025V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.025 315.552H360.252V318.52H359.025V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.925 201.553H380.797V220.027H372.925V201.553Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.249 204.041H377.475V207.009H376.249V204.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.249 209.306H377.475V212.273H376.249V209.306Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.249 214.571H377.475V217.538H376.249V214.571Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.723 201.553H356.595V220.027H348.723V201.553Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.044 204.041H353.272V207.009H352.044V204.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.044 209.306H353.272V212.273H352.044V209.306Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.044 214.571H353.272V217.538H352.044V214.571Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.636 219.307V322.82H369.885V219.307H383.062V322.82V359.496H369.885H359.636H346.457V322.82V219.307H359.636Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 222.898H379.121V225.866H377.894V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 222.898H375.616V225.866H374.39V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 228.366H379.121V231.334H377.894V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 228.366H375.616V231.334H374.39V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 233.833H379.121V236.8H377.894V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 233.833H375.616V236.8H374.39V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 239.299H379.121V242.266H377.894V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 239.299H375.616V242.266H374.39V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 244.766H379.121V247.734H377.894V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 244.766H375.616V247.734H374.39V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 250.233H379.121V253.201H377.894V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 250.233H375.616V253.201H374.39V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 255.699H379.121V258.667H377.894V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 255.699H375.616V258.667H374.39V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 261.166H379.121V264.133H377.894V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 261.166H375.616V264.133H374.39V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 266.633H379.121V269.602H377.894V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 266.633H375.616V269.602H374.39V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 272.1H379.121V275.068H377.894V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 272.1H375.616V275.068H374.39V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 277.566H379.121V280.534H377.894V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 277.566H375.616V280.534H374.39V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 283.033H379.121V286.002H377.894V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 283.033H375.616V286.002H374.39V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 288.501H379.121V291.467H377.894V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 288.501H375.616V291.467H374.39V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 293.967H379.121V296.935H377.894V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 293.967H375.616V296.935H374.39V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 299.434H379.121V302.401H377.894V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 299.434H375.616V302.401H374.39V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 304.9H379.121V307.867H377.894V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 304.9H375.616V307.867H374.39V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 310.367H379.121V313.335H377.894V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 310.367H375.616V313.335H374.39V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 315.834H379.121V318.802H377.894V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 315.834H375.616V318.802H374.39V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 321.3H379.121V324.268H377.894V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 321.3H375.616V324.268H374.39V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 326.768H379.121V329.737H377.894V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 326.768H375.616V329.737H374.39V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 332.234H379.121V335.201H377.894V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 332.234H375.616V335.201H374.39V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.894 337.701H379.121V340.668H377.894V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 337.701H375.616V340.668H374.39V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.393 326.768H370.619V329.737H369.393V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.888 326.768H367.114V329.737H365.888V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.393 332.234H370.619V335.201H369.393V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.888 332.234H367.114V335.201H365.888V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.393 337.701H370.619V340.668H369.393V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.888 337.701H367.114V340.668H365.888V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.237 326.768H363.464V329.737H362.237V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.734 326.768H359.96V329.737H358.734V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.237 332.234H363.464V335.201H362.237V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.734 332.234H359.96V335.201H358.734V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.237 337.701H363.464V340.668H362.237V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.734 337.701H359.96V340.668H358.734V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 222.898H355.13V225.866H353.904V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 222.898H351.626V225.866H350.398V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 228.366H355.13V231.334H353.904V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 228.366H351.626V231.334H350.398V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 233.833H355.13V236.8H353.904V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 233.833H351.626V236.8H350.398V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 239.299H355.13V242.266H353.904V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 239.299H351.626V242.266H350.398V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 244.766H355.13V247.734H353.904V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 244.766H351.626V247.734H350.398V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 250.233H355.13V253.201H353.904V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 250.233H351.626V253.201H350.398V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 255.699H355.13V258.667H353.904V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 255.699H351.626V258.667H350.398V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 261.166H355.13V264.133H353.904V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 261.166H351.626V264.133H350.398V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 266.633H355.13V269.602H353.904V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 266.633H351.626V269.602H350.398V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 272.1H355.13V275.068H353.904V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 272.1H351.626V275.068H350.398V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 277.566H355.13V280.534H353.904V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 277.566H351.626V280.534H350.398V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 283.033H355.13V286.002H353.904V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 283.033H351.626V286.002H350.398V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 288.501H355.13V291.467H353.904V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 288.501H351.626V291.467H350.398V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 293.967H355.13V296.935H353.904V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 293.967H351.626V296.935H350.398V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 299.434H355.13V302.401H353.904V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 299.434H351.626V302.401H350.398V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 304.9H355.13V307.867H353.904V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 304.9H351.626V307.867H350.398V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 310.367H355.13V313.335H353.904V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 310.367H351.626V313.335H350.398V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 315.834H355.13V318.802H353.904V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 315.834H351.626V318.802H350.398V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 321.3H355.13V324.268H353.904V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 321.3H351.626V324.268H350.398V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 326.768H355.13V329.737H353.904V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 326.768H351.626V329.737H350.398V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 332.234H355.13V335.201H353.904V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 332.234H351.626V335.201H350.398V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 337.701H355.13V340.668H353.904V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 337.701H351.626V340.668H350.398V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.934 337.701H344.548V359.496H329.934V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.493 327.318H353.381V359.496H340.493V327.318Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.871 331.449H349.322V334.06H347.871V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.552 331.449H346.002V334.06H344.552V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.871 337.049H349.322V339.656H347.871V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.552 337.049H346.002V339.656H344.552V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.972 337.701H399.585V359.496H384.972V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.453 327.318H389.34V359.496H376.453V327.318Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.831 331.449H385.281V334.06H383.831V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.512 331.449H381.964V334.06H380.512V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.831 337.049H385.281V339.656H383.831V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.512 337.049H381.964V339.656H380.512V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.173 318.259H761.945V321.773H601.173V318.259Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.173 314.745H761.945V315.749H601.173V314.745Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.512 280.995H705.532V344.359H688.512V280.995Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.858 274.089H706.806V344.36H703.858V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.239 274.089H689.384V344.36H687.239V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.507 314.745V288.645C700.507 286.842 698.947 285.381 697.022 285.381C695.098 285.381 693.537 286.842 693.537 288.645V314.745H700.507Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.867 321.772H698.18V344.359H695.867V321.772Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.168 280.995H675.189V344.359H658.168V280.995Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.515 274.089H676.463V344.36H673.515V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.896 274.089H659.041V344.36H656.896V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.164 314.745V288.645C670.164 286.842 668.604 285.381 666.679 285.381C664.755 285.381 663.194 286.842 663.194 288.645V314.745H670.164Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.524 321.772H667.837V344.359H665.524V321.772Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.322 326.936H544.249V359.497H528.322V326.936Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.249 329.473H541.382V332.123H540.249V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.23 329.473H538.363V332.123H537.23V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.21 329.473H535.343V332.123H534.21V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.188 329.473H532.321V332.123H531.188V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.249 334.424H541.382V337.074H540.249V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.23 334.424H538.363V337.074H537.23V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.21 334.424H535.343V337.074H534.21V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.188 334.424H532.321V337.074H531.188V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7118 277.473V290.15H12.0752V313.266H6.76612V359.496H12.0752H18.7118H23.49H31.7189H35.9663V277.473H18.7118Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0751 292.057H32.9897V294.354H12.0751V292.057Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0751 296.783H32.9897V299.082H12.0751V296.783Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0751 301.512H32.9897V303.811H12.0751V301.512Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0751 306.24H32.9897V308.537H12.0751V306.24Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0751 310.967H32.9897V313.266H12.0751V310.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76605 318.484H32.9897V320.783H6.76605V318.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76605 323.432H32.9897V325.729H6.76605V323.432Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76605 328.377H32.9897V330.676H6.76605V328.377Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76605 333.324H32.9897V335.621H6.76605V333.324Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76605 338.27H32.9897V340.569H6.76605V338.27Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7117 279.619H20.6309V281.789H18.7117V279.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7117 283.123H20.6309V285.293H18.7117V283.123Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7117 286.627H20.6309V288.797H18.7117V286.627Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8311 279.619H24.7502V281.789H22.8311V279.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8311 283.123H24.7502V285.293H22.8311V283.123Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8311 286.627H24.7502V288.797H22.8311V286.627Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9502 279.619H28.8694V281.789H26.9502V279.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9502 283.123H28.8694V285.293H26.9502V283.123Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9502 286.627H28.8694V288.797H26.9502V286.627Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0706 279.619H32.9897V281.789H31.0706V279.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0706 283.123H32.9897V285.293H31.0706V283.123Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0706 286.627H32.9897V288.797H31.0706V286.627Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.309 312.52H506.625V359.497H488.309V312.52Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.619 318.426H501.468V321.432H500.619V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.235 318.426H499.084V321.432H498.235V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.85 318.426H496.699V321.432H495.85V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.466 318.426H494.315V321.432H493.466V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.619 323.199H501.468V326.203H500.619V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.235 323.199H499.084V326.203H498.235V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.85 323.199H496.699V326.203H495.85V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.466 323.199H494.315V326.203H493.466V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.619 327.971H501.468V330.977H500.619V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.235 327.971H499.084V330.977H498.235V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.85 327.971H496.699V330.977H495.85V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.466 327.971H494.315V330.977H493.466V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.619 332.744H501.468V335.748H500.619V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.235 332.744H499.084V335.748H498.235V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.85 332.744H496.699V335.748H495.85V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.466 332.744H494.315V335.748H493.466V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.619 337.516H501.468V340.522H500.619V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.235 337.516H499.084V340.522H498.235V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.85 337.516H496.699V340.522H495.85V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.466 337.516H494.315V340.522H493.466V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.266 208.533V217.123H451.029V199.012H451.862V217.123V217.744V224.884H451.029V217.744H448.266V227.886H447.712V208.533H448.266Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.371 352.402H454.799V220.402L428.366 241.652L432.371 352.402Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.369 287.998L432.719 264.709L450.052 276.566L433.369 287.998Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.98 253.371L432.633 261.645L432.123 243.326L448.98 253.371Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.862 227.152V252.717L433.341 241.681L451.862 227.152Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.862 319.152H434.24L434.228 318.748L451.862 303.334V319.152Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.042 254.6L451.862 255.088V275.326L434.1 263.176L451.042 254.6Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.862 277.805V300.199L434.866 289.451L451.862 277.805Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.154 316.078L433.453 290.969L450.523 301.768L434.154 316.078Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.691 352.402H454.799V259.875L477.942 273.697L473.691 352.402Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.538 333.787H471.123L464.276 340.205L457.538 333.787Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.7 335.139V348.23L465.772 341.631L472.7 335.139Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.842 348.109V335.023L462.766 341.619L455.842 348.109Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.434 301.525L455.842 310.902V286.594L456.243 286.361L473.434 301.525Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.402 273.508L455.842 284.242V263.35L474.402 273.508Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.932 274.973L474.864 300.039L458.122 285.273L475.932 274.973Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.842 330.869V315.379L472.057 330.869H455.842Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.732 303.135L473.608 329.494L456.3 312.961L474.732 303.135Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.474 336.293V348.576L444.546 342.385L451.474 336.293Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.615 348.463V336.184L441.539 342.373L434.615 348.463Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.311 320.203H449.896L443.049 326.225L436.311 320.203Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.474 321.471V333.754L444.546 327.563L451.474 321.471Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.539 327.553L434.615 333.641V321.363L441.539 327.553Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.037 328.891L450.028 335.139L443.05 341.045L435.931 335.139L443.037 328.891Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.701 320.551H636.925V359.496H610.701V320.551Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.701 322.574H636.925V324.873H610.701V322.574Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.701 327.522H636.925V329.819H610.701V327.522Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.701 332.467H636.925V334.766H610.701V332.467Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.701 337.414H636.925V339.711H610.701V337.414Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.651 173.293C248.651 170.606 250.977 168.428 253.847 168.428C254.887 168.428 255.85 168.721 256.663 169.213C257.246 167.377 258.692 165.89 260.562 165.165C261.505 158.677 267.432 153.672 274.619 153.672C281.526 153.672 287.276 158.29 288.554 164.407C292.388 164.647 295.421 167.628 295.421 171.279C295.421 172.614 295.009 173.856 294.308 174.912H248.968C248.775 174.403 248.651 173.864 248.651 173.293Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.678 173.5C261.678 171.858 263.1 170.527 264.854 170.527C265.109 170.527 265.355 170.563 265.592 170.616C265.581 170.463 265.567 170.311 265.567 170.156C265.567 166.093 269.085 162.799 273.424 162.799C277.764 162.799 281.282 166.093 281.282 170.156C281.282 170.508 281.246 170.852 281.195 171.191C281.919 171.736 282.392 172.562 282.392 173.5C282.392 174.014 282.241 174.49 281.995 174.912H262.076C261.83 174.49 261.678 174.014 261.678 173.5Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.791 223.171C685.791 220.484 683.464 218.306 680.595 218.306C679.554 218.306 678.591 218.599 677.778 219.091C677.195 217.255 675.75 215.768 673.879 215.043C672.936 208.555 667.01 203.55 659.822 203.55C652.915 203.55 647.165 208.168 645.888 214.285C642.054 214.525 639.021 217.506 639.021 221.157C639.021 222.492 639.433 223.734 640.134 224.79H685.473C685.666 224.281 685.791 223.742 685.791 223.171Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.762 223.378C672.762 221.736 671.34 220.405 669.587 220.405C669.332 220.405 669.086 220.441 668.849 220.494C668.859 220.341 668.873 220.189 668.873 220.034C668.873 215.97 665.355 212.677 661.016 212.677C656.677 212.677 653.159 215.971 653.159 220.034C653.159 220.386 653.194 220.73 653.245 221.069C652.521 221.614 652.048 222.44 652.048 223.378C652.048 223.892 652.201 224.368 652.445 224.79H672.365C672.61 224.368 672.762 223.892 672.762 223.378Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.585 346.301L866.727 326.285V263.537L884.585 243.521V346.301Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 266.133H867.87V267.883H871.607V266.133Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 270.941H867.87V272.691H871.607V270.941Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 275.75H867.87V277.5H871.607V275.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 280.557H867.87V282.307H871.607V280.557Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 285.365H867.87V287.115H871.607V285.365Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 290.172H867.87V291.922H871.607V290.172Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 294.98H867.87V296.73H871.607V294.98Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 299.789H867.87V301.539H871.607V299.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 304.596H867.87V306.346H871.607V304.596Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 309.404H867.87V311.154H871.607V309.404Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 314.211H867.87V315.961H871.607V314.211Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 319.02H867.87V320.77H871.607V319.02Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.607 323.828H867.87V325.578H871.607V323.828Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.547 346.301L913.405 326.285V263.537L895.547 243.521V346.301Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 266.133H908.524V267.883H912.261V266.133Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 270.941H908.524V272.691H912.261V270.941Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 275.75H908.524V277.5H912.261V275.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 280.557H908.524V282.307H912.261V280.557Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 285.365H908.524V287.115H912.261V285.365Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 290.172H908.524V291.922H912.261V290.172Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 294.98H908.524V296.73H912.261V294.98Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 299.789H908.524V301.539H912.261V299.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 304.596H908.524V306.346H912.261V304.596Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 309.404H908.524V311.154H912.261V309.404Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 314.211H908.524V315.961H912.261V314.211Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 319.02H908.524V320.77H912.261V319.02Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.261 323.828H908.524V325.578H912.261V323.828Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.066 227.537L881.106 234.434H899.025L890.066 227.537Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.025 234.434H881.106V239.786H899.025V234.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.025 239.786H881.106L874.346 244.933H905.785L899.025 239.786Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.543 244.933H872.586V337.674H907.543V244.933Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 247.712H874.346V254.506H905.785V247.712Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 256.049H874.346V265.108H905.785V256.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 266.412H874.346V275.471H905.785V266.412Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 276.775H874.346V285.834H905.785V276.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 287.139H874.346V296.198H905.785V287.139Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 297.502H874.346V306.561H905.785V297.502Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 307.865H874.346V316.924H905.785V307.865Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 318.229H874.346V327.288H905.785V318.229Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.785 328.592H874.346V337.651H905.785V328.592Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.322 325.115L890.066 337.674L882.81 325.115V266.133L890.066 254.506L897.322 266.133V325.115Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 323.828H885.178V325.578H894.952V323.828Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 319.02H885.178V320.77H894.952V319.02Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 314.213H885.178V315.963H894.952V314.213Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 309.404H885.178V311.154H894.952V309.404Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 304.598H885.178V306.348H894.952V304.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 299.789H885.178V301.539H894.952V299.789Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 294.982H885.178V296.732H894.952V294.982Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 290.174H885.178V291.924H894.952V290.174Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 285.367H885.178V287.117H894.952V285.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 280.559H885.178V282.309H894.952V280.559Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 275.752H885.178V277.502H894.952V275.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 270.943H885.178V272.693H894.952V270.943Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.952 266.137H885.178V267.887H894.952V266.137Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.543 337.674H872.586V359.496H907.543V337.674Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.465 311.234H911.091V359.496H926.465V311.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 325.455H921.362V327.252H923.68V325.455Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 325.455H917.62V327.252H919.938V325.455Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 325.455H913.878V327.252H916.195V325.455Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 321.598H921.362V323.395H923.68V321.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 321.598H917.62V323.395H919.938V321.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 321.598H913.878V323.395H916.195V321.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 317.74H921.362V319.537H923.68V317.74Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 317.74H917.62V319.537H919.938V317.74Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 317.74H913.878V319.537H916.195V317.74Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 313.883H921.362V315.68H923.68V313.883Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 313.883H917.62V315.68H919.938V313.883Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 313.883H913.878V315.68H916.195V313.883Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 337.027H921.362V338.824H923.68V337.027Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 337.027H917.62V338.824H919.938V337.027Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 337.027H913.878V338.824H916.195V337.027Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 333.17H921.362V334.967H923.68V333.17Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 333.17H917.62V334.967H919.938V333.17Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 333.17H913.878V334.967H916.195V333.17Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.68 329.313H921.362V331.11H923.68V329.313Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.938 329.313H917.62V331.11H919.938V329.313Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.195 329.313H913.878V331.11H916.195V329.313Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.98 269.328H1256.36V359.496H1307.98V269.328Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.05 79.337H1281.29V103.859H1283.05V79.337Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.25 102.211H1279.09V116.636H1285.25V102.211Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.28 124.569C1292.06 119.845 1288.6 115.426 1283.55 114.698C1278.51 113.971 1273.79 117.211 1273.01 121.935C1272.23 126.659 1275.69 131.078 1280.74 131.806C1285.79 132.533 1290.51 129.293 1291.28 124.569Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.13 133.697C1295.2 127.518 1290.72 121.696 1284.12 120.693C1277.52 119.69 1271.3 123.886 1270.23 130.065C1269.16 136.244 1273.64 142.066 1280.24 143.069C1286.84 144.072 1293.06 139.876 1294.13 133.697Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.17 152.781C1290.03 152.781 1296.4 146.817 1296.4 139.46C1296.4 132.103 1290.03 126.139 1282.17 126.139C1274.31 126.139 1267.94 132.103 1267.94 139.46C1267.94 146.817 1274.31 152.781 1282.17 152.781Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.57 174.231C1298.57 182.515 1291.39 189.231 1282.55 189.231H1281.79C1272.95 189.231 1265.77 182.515 1265.77 174.231V149.004C1265.77 140.72 1272.95 134.004 1281.79 134.004H1282.55C1291.39 134.004 1298.57 140.72 1298.57 149.004V174.231Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.02 144.25H1275.48V186.082H1277.02V144.25Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.94 144.25H1281.4V186.082H1282.94V144.25Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.86 144.25H1287.32V186.082H1288.86V144.25Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.8 169.494H1260.54V269.328H1303.8V169.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.21 182.494V169.494H1267.13V182.494H1260.54V269.328H1303.8V182.494H1297.21Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.8 277.328H1252.18V358.662H1269.8V277.328Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.8 289.994H1246.48V359.496H1269.8V289.994Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.16 277.328H1294.54V358.662H1312.16V277.328Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.86 289.994H1294.54V359.496H1317.86V289.994Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.18 314.41H1294.54V346.256H1269.8V314.41H1257.16H1240.25V359.496H1257.16H1307.18H1324.09V314.41H1307.18Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.75 321.285H1246.91V322.285H1251.75V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.75 325.785H1246.91V326.785H1251.75V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.75 330.285H1246.91V331.285H1251.75V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.75 334.785H1246.91V335.785H1251.75V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.55 321.285H1257.71V322.285H1262.55V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.55 325.785H1257.71V326.785H1262.55V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.55 330.285H1257.71V331.285H1262.55V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.55 334.785H1257.71V335.785H1262.55V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.63 321.285H1301.79V322.285H1306.63V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.63 325.785H1301.79V326.785H1306.63V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.63 330.285H1301.79V331.285H1306.63V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.63 334.785H1301.79V335.785H1306.63V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.43 321.285H1312.59V322.285H1317.43V321.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.43 325.785H1312.59V326.785H1317.43V325.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.43 330.285H1312.59V331.285H1317.43V330.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.43 334.785H1312.59V335.785H1317.43V334.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.59 297.16H1252.52V299.91H1253.59V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.25 297.16H1257.18V299.91H1258.25V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.91 297.16H1261.84V299.91H1262.91V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.59 305.16H1252.52V307.91H1253.59V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.25 305.16H1257.18V307.91H1258.25V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.91 305.16H1261.84V307.91H1262.91V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.64 297.16H1300.58V299.91H1301.64V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.3 297.16H1305.24V299.91H1306.3V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.97 297.16H1309.9V299.91H1310.97V297.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.64 305.16H1300.58V307.91H1301.64V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.3 305.16H1305.24V307.91H1306.3V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.97 305.16H1309.9V307.91H1310.97V305.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 186.786H1265.35V187.661H1270.54V186.786Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 191.223H1265.35V192.098H1270.54V191.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 195.661H1265.35V196.536H1270.54V195.661Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 200.098H1265.35V200.973H1270.54V200.098Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 204.536H1265.35V205.411H1270.54V204.536Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 208.973H1265.35V209.848H1270.54V208.973Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 213.411H1265.35V214.286H1270.54V213.411Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 217.848H1265.35V218.723H1270.54V217.848Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 222.286H1265.35V223.161H1270.54V222.286Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 226.723H1265.35V227.598H1270.54V226.723Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 231.161H1265.35V232.036H1270.54V231.161Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 235.598H1265.35V236.473H1270.54V235.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 240.036H1265.35V240.911H1270.54V240.036Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 244.473H1265.35V245.348H1270.54V244.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 248.91H1265.35V249.785H1270.54V248.91Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 253.348H1265.35V254.223H1270.54V253.348Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 257.785H1265.35V258.66H1270.54V257.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 262.223H1265.35V263.098H1270.54V262.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 186.786H1292.95V187.661H1298.14V186.786Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 191.223H1292.95V192.098H1298.14V191.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 195.661H1292.95V196.536H1298.14V195.661Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 200.098H1292.95V200.973H1298.14V200.098Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 204.536H1292.95V205.411H1298.14V204.536Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 208.973H1292.95V209.848H1298.14V208.973Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 213.411H1292.95V214.286H1298.14V213.411Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 217.848H1292.95V218.723H1298.14V217.848Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 222.286H1292.95V223.161H1298.14V222.286Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 226.723H1292.95V227.598H1298.14V226.723Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 231.161H1292.95V232.036H1298.14V231.161Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 235.598H1292.95V236.473H1298.14V235.598Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 240.036H1292.95V240.911H1298.14V240.036Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 244.473H1292.95V245.348H1298.14V244.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 248.91H1292.95V249.785H1298.14V248.91Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 253.348H1292.95V254.223H1298.14V253.348Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 257.785H1292.95V258.66H1298.14V257.785Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.14 262.223H1292.95V263.098H1298.14V262.223Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.62 175.911H1275.85V346.256H1276.62V175.911Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.55 175.911H1281.78V346.256H1282.55V175.911Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.49 175.911H1287.72V346.256H1288.49V175.911Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.39 328.639V345.244H1363.06V328.639H1355.52V359.496H1398.93V328.639H1391.39Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.92 314.635H1390V330.992H1399.92V314.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.12 314.635H1354.2V330.992H1364.12V314.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.03 287H1445.09C1445.09 287 1419.41 320.832 1377.06 320.832C1334.71 320.832 1309.03 287 1309.03 287Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.27 321.93H1392.93V323.615H1397.27V321.93Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.27 324.508H1392.93V326.196H1397.27V324.508Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.27 327.088H1392.93V328.773H1397.27V327.088Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.63 321.93H1357.28V323.615H1361.63V321.93Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.63 324.508H1357.28V326.196H1361.63V324.508Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.63 327.088H1357.28V328.773H1361.63V327.088Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.15 287V300.758",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.53 306.897V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.89 311.703V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.02 315.338V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.11 318V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.09 319.904V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 320.693V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.31 320.756V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.45 320.008V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.49 318.471V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.57 315.91V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.85 312.391V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.9 307.961V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.21 302.242V287",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.08 287V295.592",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.95 305.594C1409.95 305.594 1394.73 312.469 1377.97 312.469C1359.22 312.469 1346 305.594 1346 305.594V290.344H1409.95V305.594H1409.95Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.09 291.469H1388.96V294.219H1393.09V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.47 291.469H1373.34V294.219H1377.47V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.3 291.469H1394.16V294.219H1398.3V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.16 309.502C1395.62 309.187 1397.01 308.854 1398.3 308.514V307.594H1394.16V309.502Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.89 291.469H1383.75V294.219H1387.89V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.37 308.227C1400.14 308.014 1400.88 307.803 1401.57 307.594H1399.37V308.227Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.51 291.469H1399.37V294.219H1403.51V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.68 291.469H1378.54V294.219H1382.68V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.55 299.344H1404.57V302.469H1408.55V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.65 303.469H1352.51V306.594H1356.65V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.55 291.469H1404.57V294.219H1408.55V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.57 306.594H1404.7C1407.13 305.768 1408.55 305.168 1408.55 305.168V303.469H1404.57V306.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.65 299.344H1352.51V302.469H1356.65V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.44 295.219H1347.4V298.344H1351.44V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.85 291.469H1357.72V294.219H1361.85V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.44 291.469H1347.4V294.219H1351.44V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.65 291.469H1352.51V294.219H1356.65V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 291.469H1368.13V294.219H1372.27V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.06 291.469H1362.92V294.219H1367.06V291.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.44 299.344H1347.4V302.469H1351.44V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.92 309.908C1364.24 310.158 1365.62 310.388 1367.06 310.588V307.594H1362.92V309.908Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.72 308.732C1359 309.066 1360.38 309.392 1361.85 309.695V307.593H1357.72V308.732Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.65 308.445V307.593H1353.78C1354.66 307.873 1355.61 308.16 1356.65 308.445Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.75 310.719H1387.15C1387.4 310.686 1387.64 310.655 1387.89 310.619V307.594H1383.75V310.719Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.4 305.168C1347.4 305.168 1348.63 305.768 1350.86 306.594H1351.44V303.469H1347.4V305.168Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.96 310.463C1390.38 310.244 1391.77 309.994 1393.09 309.725V307.594H1388.96V310.463Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.68 303.469H1378.54V306.594H1382.68V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.09 303.469H1388.96V306.594H1393.09V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.89 299.344H1383.75V302.469H1387.89V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.09 299.344H1388.96V302.469H1393.09V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.89 295.219H1383.75V298.344H1387.89V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.89 303.469H1383.75V306.594H1387.89V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.68 299.344H1378.54V302.469H1382.68V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.68 295.219H1378.54V298.344H1382.68V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.09 295.219H1388.96V298.344H1393.09V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.51 295.219H1399.37V298.344H1403.51V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.55 295.219H1404.57V298.344H1408.55V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.51 299.344H1399.37V302.469H1403.51V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.51 303.469H1399.37V306.594H1403.51V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.3 303.469H1394.16V306.594H1398.3V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.3 299.344H1394.16V302.469H1398.3V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.3 295.219H1394.16V298.344H1398.3V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.47 299.344H1373.34V302.469H1377.47V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.06 299.344H1362.92V302.469H1367.06V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.06 303.469H1362.92V306.594H1367.06V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.85 295.219H1357.72V298.344H1361.85V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.06 295.219H1362.92V298.344H1367.06V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.85 303.469H1357.72V306.594H1361.85V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.68 307.594H1378.54V310.719H1382.68V307.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.85 299.344H1357.72V302.469H1361.85V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 307.594H1368.13V310.719H1372.27V307.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 303.469H1368.13V306.594H1372.27V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.65 295.219H1352.51V298.344H1356.65V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.47 295.219H1373.34V298.344H1377.47V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.47 303.469H1373.34V306.594H1377.47V303.469Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.47 307.594H1373.34V310.719H1377.47V307.594Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 295.219H1368.13V298.344H1372.27V295.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 299.344H1368.13V302.469H1372.27V299.344Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.83 336.51H1335.19V359.496H1321.18L1328.83 336.51Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 338.094H1335.19V343.844H1328.88L1330.35 338.094Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.62 336.51H1419.26V359.496H1433.28L1425.62 336.51Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.11 338.094H1419.26V343.844H1425.58L1424.11 338.094Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.48 297.468H1139.55V303.403H1242.48V297.468Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.88 315.685H1138.13V359.497H1143.88V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.26 317.041C1144.26 317.317 1144.02 317.543 1143.72 317.543H1138.29C1137.99 317.543 1137.75 317.317 1137.75 317.041C1137.75 316.766 1137.99 316.539 1138.29 316.539H1143.72C1144.02 316.539 1144.26 316.766 1144.26 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.92 316.279C1144.92 316.699 1144.56 317.041 1144.11 317.041H1137.9C1137.46 317.041 1137.09 316.699 1137.09 316.279C1137.09 315.859 1137.46 315.517 1137.9 315.517H1144.11C1144.56 315.518 1144.92 315.859 1144.92 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.78 318.487H1139.31V356.095H1139.78V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.24 318.487H1140.77V356.095H1141.24V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.69 318.487H1142.23V356.095H1142.69V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.89 315.685H1158.13V359.497H1163.89V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.26 317.041C1164.26 317.317 1164.02 317.543 1163.73 317.543H1158.29C1158 317.543 1157.76 317.317 1157.76 317.041C1157.76 316.766 1158 316.539 1158.29 316.539H1163.73C1164.02 316.539 1164.26 316.766 1164.26 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.92 316.279C1164.92 316.699 1164.56 317.041 1164.11 317.041H1157.91C1157.46 317.041 1157.09 316.699 1157.09 316.279C1157.09 315.859 1157.46 315.517 1157.91 315.517H1164.11C1164.56 315.518 1164.92 315.859 1164.92 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.79 318.487H1159.32V356.095H1159.79V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.24 318.487H1160.78V356.095H1161.24V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.7 318.487H1162.23V356.095H1162.7V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.89 315.685H1178.14V359.497H1183.89V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.27 317.041C1184.27 317.317 1184.03 317.543 1183.73 317.543H1178.3C1178 317.543 1177.76 317.317 1177.76 317.041C1177.76 316.766 1178 316.539 1178.3 316.539H1183.73C1184.03 316.539 1184.27 316.766 1184.27 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.93 316.279C1184.93 316.699 1184.56 317.041 1184.11 317.041H1177.91C1177.46 317.041 1177.1 316.699 1177.1 316.279C1177.1 315.859 1177.46 315.517 1177.91 315.517H1184.11C1184.57 315.518 1184.93 315.859 1184.93 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.79 318.487H1179.32V356.095H1179.79V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.25 318.487H1180.78V356.095H1181.25V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.7 318.487H1182.24V356.095H1182.7V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.9 315.685H1198.14V359.497H1203.9V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.27 317.041C1204.27 317.317 1204.03 317.543 1203.74 317.543H1198.3C1198.01 317.543 1197.77 317.317 1197.77 317.041C1197.77 316.766 1198.01 316.539 1198.3 316.539H1203.74C1204.03 316.539 1204.27 316.766 1204.27 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.93 316.279C1204.93 316.699 1204.57 317.041 1204.12 317.041H1197.92C1197.47 317.041 1197.1 316.699 1197.1 316.279C1197.1 315.859 1197.47 315.517 1197.92 315.517H1204.12C1204.57 315.518 1204.93 315.859 1204.93 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 318.487H1199.33V356.095H1199.8V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.25 318.487H1200.78V356.095H1201.25V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.71 318.487H1202.24V356.095H1202.71V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.9 315.685H1218.15V359.497H1223.9V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.28 317.041C1224.28 317.317 1224.04 317.543 1223.74 317.543H1218.3C1218.01 317.543 1217.77 317.317 1217.77 317.041C1217.77 316.766 1218.01 316.539 1218.3 316.539H1223.74C1224.04 316.539 1224.28 316.766 1224.28 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.94 316.279C1224.94 316.699 1224.57 317.041 1224.12 317.041H1217.92C1217.47 317.041 1217.11 316.699 1217.11 316.279C1217.11 315.859 1217.47 315.517 1217.92 315.517H1224.12C1224.57 315.518 1224.94 315.859 1224.94 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.8 318.487H1219.33V356.095H1219.8V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.26 318.487H1220.79V356.095H1221.26V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.71 318.487H1222.25V356.095H1222.71V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.9 315.685H1238.15V359.497H1243.9V315.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 317.041C1244.28 317.317 1244.04 317.543 1243.75 317.543H1238.31C1238.01 317.543 1237.77 317.317 1237.77 317.041C1237.77 316.766 1238.01 316.539 1238.31 316.539H1243.75C1244.04 316.539 1244.28 316.766 1244.28 317.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.94 316.279C1244.94 316.699 1244.58 317.041 1244.13 317.041H1237.93C1237.48 317.041 1237.11 316.699 1237.11 316.279C1237.11 315.859 1237.48 315.517 1237.93 315.517H1244.13C1244.58 315.518 1244.94 315.859 1244.94 316.279Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.81 318.487H1239.34V356.095H1239.81V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.26 318.487H1240.79V356.095H1241.26V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.72 318.487H1242.25V356.095H1242.72V318.487Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.97 308.269H1138.06V313.426H1243.97V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.17 308.269H1138.06V313.426H1141.17V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.97 308.269H1240.86V313.426H1243.97V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.77 308.269H1145.38V313.426H1147.77V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.11 308.269H1151.72V313.426H1154.11V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.46 308.269H1158.07V313.426H1160.46V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.8 308.269H1164.41V313.426H1166.8V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.14 308.269H1170.75V313.426H1173.14V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.48 308.269H1177.09V313.426H1179.48V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.83 308.269H1183.44V313.426H1185.83V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.17 308.269H1189.78V313.426H1192.17V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.51 308.269H1196.12V313.426H1198.51V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.86 308.269H1202.47V313.426H1204.86V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.2 308.269H1208.81V313.426H1211.2V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.54 308.269H1215.15V313.426H1217.54V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.89 308.269H1221.5V313.426H1223.89V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.23 308.269H1227.84V313.426H1230.23V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.57 308.269H1234.18V313.426H1236.57V308.269Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.02 313.426H1138.02V315.518H1244.02V313.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.83 306.01H1134.2V308.849H1247.83V306.01Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.7 304.652H1132.33L1134.2 306.01H1247.83L1249.7 304.652Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.15 303.403H1137.88V304.652H1244.15V303.403Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.46 295.326H1135.57V297.468H1246.46V295.326Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.14 293.673H1175.9V295.326H1206.14V293.673Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.01 295.326H1174.02V297.468H1208.01V295.326Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.15 298.44H1168.88V298.831H1213.15V298.44Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.39 299.674H1165.65V300.063H1216.39V299.674Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.05 300.906H1157.99V301.295H1224.05V300.906Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.98 302.139H1153.05V302.528H1228.98V302.139Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.97 297.468H1176.06V304.652H1205.97V297.468Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.9 298.125H1178.14V303.403H1203.9V298.125Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.11 284.075C1203.09 284.031 1202.3 284.316 1201.9 285.177C1201.78 285.44 1201.63 285.701 1201.56 285.978C1201.32 286.947 1200.79 287.553 1199.62 287.44C1199.51 287.43 1199.38 287.481 1199.26 287.507C1198.56 287.656 1198.21 287.99 1198.22 288.659C1198.23 289.082 1198.34 289.531 1198.53 289.914C1198.8 290.465 1199.08 290.982 1198.81 291.601C1198.47 292.372 1198.64 293.016 1199.35 293.53C1199.36 293.538 1199.34 293.594 1199.32 293.641C1198.72 293.641 1198.12 293.641 1197.47 293.641C1197.39 291.586 1197.32 289.561 1197.25 287.565C1196.91 287.469 1196.54 287.463 1196.36 287.29C1196.14 287.095 1196 286.755 1195.99 286.469C1195.96 286.011 1196.06 285.546 1196.12 285.083C1196.27 283.81 1196.16 283.673 1194.82 283.499C1194.77 282.824 1194.74 282.135 1194.65 281.454C1194.6 281.145 1194.51 280.79 1194.3 280.569C1194.08 280.342 1193.7 280.139 1193.39 280.135C1192.97 280.132 1192.92 280.516 1192.89 280.867C1192.88 280.998 1192.63 281.11 1192.49 281.231C1192.39 281.048 1192.22 280.869 1192.21 280.685C1192.21 280.519 1192.39 280.351 1192.49 280.183C1192.8 279.651 1192.66 279.398 1192.01 279.357C1191.62 279.332 1191.21 279.351 1190.8 279.351C1190.73 278.632 1190.6 278.049 1191.58 277.656C1192.75 277.191 1192.68 275.808 1191.58 275.148C1191.41 275.045 1191.24 274.949 1190.97 274.794C1192.26 274.568 1192.77 273.628 1193.49 272.934C1193.61 272.826 1193.64 272.62 1193.66 272.455C1193.68 272.154 1193.5 272.004 1193.19 272.148C1192.4 272.523 1191.62 272.923 1190.98 273.245C1190.86 273.101 1190.7 272.734 1190.48 272.689C1189.9 272.573 1189.97 273.05 1189.97 273.252C1189.28 272.907 1188.56 272.536 1187.83 272.195C1187.68 272.123 1187.46 272.161 1187.27 272.147C1187.27 272.33 1187.24 272.513 1187.26 272.693C1187.27 272.798 1187.34 272.921 1187.42 272.994C1188.14 273.607 1188.6 274.527 1189.68 274.726C1189.71 274.732 1189.73 274.816 1189.77 274.892C1188.99 275.22 1188.35 275.674 1188.44 276.558C1188.53 277.433 1189.24 277.79 1190.05 278.019C1190.05 278.57 1190.08 279.107 1190.05 279.639C1190.03 279.984 1189.85 280.114 1189.43 280.027C1188.7 279.879 1188.25 280.2 1188.26 280.89C1188.27 281.782 1188.39 282.671 1188.47 283.56C1188.52 284.075 1188.6 284.585 1188.63 285.101C1188.63 285.261 1188.53 285.478 1188.4 285.578C1188.05 285.851 1187.65 286.074 1187.12 286.406C1187.23 285.926 1187.32 285.582 1187.39 285.235C1187.5 284.619 1187.15 284.072 1186.6 283.995C1186.08 283.922 1185.57 284.318 1185.46 284.9C1185.43 285.088 1185.47 285.286 1185.43 285.474C1185.27 286.378 1185.35 287.327 1184.61 288.111C1184.35 288.387 1184.32 288.933 1184.34 289.348C1184.36 289.777 1184.6 290.19 1184.69 290.62C1184.9 291.609 1185.07 292.603 1185.25 293.634C1184.3 293.634 1183.46 293.634 1182.52 293.634C1182.72 293.432 1182.9 293.314 1182.98 293.154C1183.13 292.823 1183.39 292.419 1183.3 292.13C1183.01 291.222 1183.06 290.405 1183.65 289.628C1183.71 289.551 1183.74 289.454 1183.77 289.362C1184.07 288.405 1183.66 287.53 1182.67 287.51C1181.19 287.479 1180.61 286.716 1180.29 285.547C1180.24 285.345 1180.13 285.154 1180.03 284.967C1179.66 284.291 1179.02 283.969 1178.22 284.049C1178.03 284.066 1177.85 284.115 1177.67 284.115C1177.27 284.108 1177.22 284.26 1177.29 284.617C1177.39 285.176 1177.46 285.755 1177.42 286.318C1177.37 287.168 1177.59 287.424 1178.58 287.374C1178.02 288.032 1178.01 288.714 1178.28 289.454C1178.35 289.626 1178.12 289.897 1178 290.118C1177.91 290.313 1177.69 290.503 1177.7 290.691C1177.71 291.36 1177.74 292.034 1177.88 292.684C1177.92 292.873 1178.35 292.987 1178.59 293.135C1178.68 292.891 1178.81 292.653 1178.85 292.401C1178.86 292.278 1178.69 292.139 1178.63 291.999C1178.43 291.556 1178.27 291.012 1178.76 290.749C1179.19 290.517 1179.79 290.54 1180.32 290.483C1180.38 290.479 1180.5 290.711 1180.52 290.841C1180.61 291.406 1180.67 291.975 1180.73 292.544C1180.81 293.301 1180.44 293.673 1179.64 293.673H1202.42C1201.51 293.673 1201.18 293.322 1201.28 292.484C1201.35 291.991 1201.38 291.496 1201.46 291.006C1201.48 290.834 1201.61 290.53 1201.68 290.535C1202.2 290.572 1202.81 290.539 1203.24 290.78C1203.72 291.058 1203.58 291.623 1203.34 292.083C1203.31 292.151 1203.23 292.213 1203.23 292.283C1203.21 292.533 1203.17 292.795 1203.23 293.034C1203.25 293.112 1203.62 293.22 1203.68 293.166C1203.88 293.004 1204.07 292.784 1204.13 292.557C1204.25 292.094 1204.27 291.612 1204.34 291.137C1204.39 290.72 1204.36 290.352 1203.93 290.074C1203.78 289.982 1203.67 289.664 1203.72 289.506C1203.98 288.777 1204.03 288.088 1203.45 287.43C1204.51 287.408 1204.64 287.247 1204.58 286.283C1204.55 285.795 1204.5 285.267 1204.66 284.816C1204.86 284.229 1204.84 284.105 1204.11 284.075ZM1186.56 293.641C1186.56 292.987 1186.56 292.344 1186.56 291.703C1186.62 291.7 1186.67 291.694 1186.73 291.692C1186.75 292.051 1186.76 292.413 1186.8 292.77C1186.85 293.176 1186.9 293.614 1187.55 293.463C1187.92 292.852 1187.25 292.111 1187.73 291.516C1187.8 291.52 1187.86 291.521 1187.93 291.524C1187.97 292.215 1188 292.907 1188.04 293.641C1187.5 293.641 1187.06 293.641 1186.56 293.641ZM1193.27 293.641C1191.82 293.641 1190.4 293.641 1188.91 293.641C1188.95 292.987 1188.99 292.37 1189.03 291.735C1190.28 291.735 1191.5 291.735 1192.69 291.735C1192.77 291.985 1192.79 292.312 1192.92 292.358C1193.73 292.648 1193.32 293.17 1193.27 293.641ZM1194.52 293.645C1194.43 293.641 1194.35 293.635 1194.26 293.631C1194.3 293.125 1194.34 292.621 1194.38 292.115C1194.42 292.119 1194.47 292.121 1194.52 292.123C1194.52 292.631 1194.52 293.139 1194.52 293.645Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.788 261.246H987.352L992.598 359.496H975.904L981.788 261.246Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.08 247.549H983.059L984.569 197.382L986.08 247.549Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.465 226.113C988.465 227.182 986.685 228.049 984.49 228.049C982.295 228.049 980.516 227.183 980.516 226.113C980.516 225.043 982.295 224.177 984.49 224.177C986.685 224.177 988.465 225.044 988.465 226.113Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.875 245.465H981.947V253.504H986.875V245.465Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.577 250.379H979.721V254.547H989.577V250.379Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.394 263.031L987.602 265.928H981.507L975.904 263.031V256.332L979.721 253.318H989.578L993.394 256.332V263.031Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.394 257.006H975.904V262.272H993.394V257.006Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.394 259.119H975.904V260.265H993.394V259.119Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.97 208.566H1049.51V220.22H1062.97V208.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 340.568H1039.09V194.058L1052.3 208.566V340.568Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 212.134H1039.09V215.701H1045.7V212.134Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 327.838H1039.09V331.404H1045.7V327.838Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 215.701H1039.09V225.046H1045.7V215.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 225.046H1039.09V234.391H1045.7V225.046Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 234.391H1039.09V243.736H1045.7V234.391Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 243.735H1039.09V253.08H1045.7V243.735Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 253.08H1039.09V262.424H1045.7V253.08Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 262.424H1039.09V271.77H1045.7V262.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 271.77H1039.09V281.116H1045.7V271.77Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 281.115H1039.09V290.459H1045.7V281.115Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 290.459H1039.09V299.805H1045.7V290.459Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 299.805H1039.09V309.149H1045.7V299.805Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 309.148H1039.09V318.494H1045.7V309.148Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 318.494H1039.09V327.838H1045.7V318.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 218.683H1052.3V225.046H1070.22V218.683Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 225.046H1052.3V231.409H1070.22V225.046Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 231.409H1052.3V237.772H1070.22V231.409Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 237.773H1052.3V244.136H1070.22V237.773Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 244.136H1052.3V250.499H1070.22V244.136Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 250.499H1052.3V256.861H1070.22V250.499Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 256.861H1052.3V266.578H1070.22V256.861Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 266.578V278.496L1045.7 282.496V332.746H1039.09V359.496H1045.7H1070.23V332.746V266.578H1052.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 286.775H1051.32V291.375H1052.3V286.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 286.775H1057.39V291.375H1058.37V286.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 286.775H1063.46V291.375H1064.45V286.775Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 295.205H1051.32V299.805H1052.3V295.205Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 295.205H1057.39V299.805H1058.37V295.205Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 295.205H1063.46V299.805H1064.45V295.205Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 303.635H1051.32V308.235H1052.3V303.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 303.635H1057.39V308.235H1058.37V303.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 303.635H1063.46V308.235H1064.45V303.635Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 312.065H1051.32V316.665H1052.3V312.065Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 312.065H1057.39V316.665H1058.37V312.065Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 312.065H1063.46V316.665H1064.45V312.065Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 320.494H1051.32V325.094H1052.3V320.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 320.494H1057.39V325.094H1058.37V320.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 320.494H1063.46V325.094H1064.45V320.494Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 328.924H1051.32V333.524H1052.3V328.924Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 328.924H1057.39V333.524H1058.37V328.924Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 328.924H1063.46V333.524H1064.45V328.924Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 337.354H1051.32V341.954H1052.3V337.354Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.37 337.354H1057.39V341.954H1058.37V337.354Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.45 337.354H1063.46V341.954H1064.45V337.354Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.146 225.566H951.217V242.344H952.146V225.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.752 251.418H949.612L950.283 239.238H953.204L953.752 251.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.147 251.418H951.217L951.683 239.238L952.147 251.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.875 249.018H942.494V257.36H960.875V249.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.172 253.189L951.57 250.938L939.966 253.189V359.496H963.172V253.189Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.966 348.545L951.57 250.938L963.172 348.545H939.966Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.06 307.586H1082.42V359.496H1126.06V307.586Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.03 164.292H1102.45C1102.46 164.67 1102.46 165.052 1102.46 165.435C1102.46 173.23 1100.75 180.039 1098.19 183.725V184.047H1110.29V183.724C1107.73 180.037 1106.02 173.229 1106.02 165.435C1106.02 165.052 1106.02 164.67 1106.03 164.292Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.75 149.839H1103.73V164.292H1104.75V149.839Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.46 183.111H1094.02V189.246H1114.46V183.111Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.68 188.206H1090.8V192.053H1117.68V188.206Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.56 191.534H1087.92V192.677H1120.56V191.534Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.68 192.677H1090.8V359.496H1117.68V192.677Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.23 195.284H1095V198.251H1096.23V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 195.284H1098.51V198.251H1099.73V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 200.75H1098.51V203.718H1099.73V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 206.217H1098.51V209.184H1099.73V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 211.684H1098.51V214.652H1099.73V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 217.15H1098.51V220.117H1099.73V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 222.617H1098.51V225.584H1099.73V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 228.084H1098.51V231.052H1099.73V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 233.55H1098.51V236.518H1099.73V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 239.018H1098.51V241.985H1099.73V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 244.484H1098.51V247.451H1099.73V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 249.951H1098.51V252.919H1099.73V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 255.418H1098.51V258.385H1099.73V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 260.885H1098.51V263.854H1099.73V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 266.352H1098.51V269.319H1099.73V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 271.817H1098.51V274.785H1099.73V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 277.285H1098.51V280.252H1099.73V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 282.752H1098.51V285.719H1099.73V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 288.219H1098.51V291.187H1099.73V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 293.685H1098.51V296.653H1099.73V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 195.284H1101.38V198.251H1102.6V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 195.284H1104.88V198.251H1106.11V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 200.75H1101.38V203.718H1102.6V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 200.75H1104.88V203.718H1106.11V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 206.217H1101.38V209.184H1102.6V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 206.217H1104.88V209.184H1106.11V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 211.684H1101.38V214.652H1102.6V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 211.684H1104.88V214.652H1106.11V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 217.15H1101.38V220.117H1102.6V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 217.15H1104.88V220.117H1106.11V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 222.617H1101.38V225.584H1102.6V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 222.617H1104.88V225.584H1106.11V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 228.084H1101.38V231.052H1102.6V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 228.084H1104.88V231.052H1106.11V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 233.55H1101.38V236.518H1102.6V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 233.55H1104.88V236.518H1106.11V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 239.018H1101.38V241.985H1102.6V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 239.018H1104.88V241.985H1106.11V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 244.484H1101.38V247.451H1102.6V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 244.484H1104.88V247.451H1106.11V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 249.951H1101.38V252.919H1102.6V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 249.951H1104.88V252.919H1106.11V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 255.418H1101.38V258.385H1102.6V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 255.418H1104.88V258.385H1106.11V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 260.885H1101.38V263.854H1102.6V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 260.885H1104.88V263.854H1106.11V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 266.352H1101.38V269.319H1102.6V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 266.352H1104.88V269.319H1106.11V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 271.817H1101.38V274.785H1102.6V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 271.817H1104.88V274.785H1106.11V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 277.285H1101.38V280.252H1102.6V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 277.285H1104.88V280.252H1106.11V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 282.752H1101.38V285.719H1102.6V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 282.752H1104.88V285.719H1106.11V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 288.219H1101.38V291.187H1102.6V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 288.219H1104.88V291.187H1106.11V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 293.685H1101.38V296.653H1102.6V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 293.685H1104.88V296.653H1106.11V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 195.284H1108.75V198.251H1109.98V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.48 195.284H1112.25V198.251H1113.48V195.284Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 200.75H1108.75V203.718H1109.98V200.75Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 206.217H1108.75V209.184H1109.98V206.217Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 211.684H1108.75V214.652H1109.98V211.684Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 217.15H1108.75V220.117H1109.98V217.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 222.617H1108.75V225.584H1109.98V222.617Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 228.084H1108.75V231.052H1109.98V228.084Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 233.55H1108.75V236.518H1109.98V233.55Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 239.018H1108.75V241.985H1109.98V239.018Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 244.484H1108.75V247.451H1109.98V244.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 249.951H1108.75V252.919H1109.98V249.951Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 255.418H1108.75V258.385H1109.98V255.418Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 260.885H1108.75V263.854H1109.98V260.885Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 266.352H1108.75V269.319H1109.98V266.352Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 271.817H1108.75V274.785H1109.98V271.817Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 277.285H1108.75V280.252H1109.98V277.285Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 282.752H1108.75V285.719H1109.98V282.752Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 288.219H1108.75V291.187H1109.98V288.219Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 293.685H1108.75V296.653H1109.98V293.685Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 299.15H1098.51V302.119H1099.73V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 304.619H1098.51V307.586H1099.73V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 310.085H1098.51V313.053H1099.73V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.73 315.552H1098.51V318.52H1099.73V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 299.15H1101.38V302.119H1102.6V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 299.15H1104.88V302.119H1106.11V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 304.619H1101.38V307.586H1102.6V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 304.619H1104.88V307.586H1106.11V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 310.085H1101.38V313.053H1102.6V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 310.085H1104.88V313.053H1106.11V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.6 315.552H1101.38V318.52H1102.6V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 315.552H1104.88V318.52H1106.11V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 299.15H1108.75V302.119H1109.98V299.15Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 304.619H1108.75V307.586H1109.98V304.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 310.085H1108.75V313.053H1109.98V310.085Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.98 315.552H1108.75V318.52H1109.98V315.552Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.08 201.553H1088.2V220.027H1096.08V201.553Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 204.041H1091.52V207.009H1092.75V204.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 209.306H1091.52V212.273H1092.75V209.306Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 214.571H1091.52V217.538H1092.75V214.571Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.28 201.553H1112.41V220.027H1120.28V201.553Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.96 204.041H1115.73V207.009H1116.96V204.041Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.96 209.306H1115.73V212.273H1116.96V209.306Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.96 214.571H1115.73V217.538H1116.96V214.571Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.36 219.307V322.82H1099.11V219.307H1085.94V322.82V359.496H1099.11H1109.36H1122.54V322.82V219.307H1109.36Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 222.898H1089.88V225.866H1091.11V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 222.898H1093.38V225.866H1094.61V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 228.366H1089.88V231.334H1091.11V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 228.366H1093.38V231.334H1094.61V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 233.833H1089.88V236.8H1091.11V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 233.833H1093.38V236.8H1094.61V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 239.299H1089.88V242.266H1091.11V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 239.299H1093.38V242.266H1094.61V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 244.766H1089.88V247.734H1091.11V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 244.766H1093.38V247.734H1094.61V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 250.233H1089.88V253.201H1091.11V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 250.233H1093.38V253.201H1094.61V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 255.699H1089.88V258.667H1091.11V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 255.699H1093.38V258.667H1094.61V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 261.166H1089.88V264.133H1091.11V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 261.166H1093.38V264.133H1094.61V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 266.633H1089.88V269.602H1091.11V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 266.633H1093.38V269.602H1094.61V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 272.1H1089.88V275.068H1091.11V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 272.1H1093.38V275.068H1094.61V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 277.566H1089.88V280.534H1091.11V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 277.566H1093.38V280.534H1094.61V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 283.033H1089.88V286.002H1091.11V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 283.033H1093.38V286.002H1094.61V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 288.501H1089.88V291.467H1091.11V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 288.501H1093.38V291.467H1094.61V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 293.967H1089.88V296.935H1091.11V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 293.967H1093.38V296.935H1094.61V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 299.434H1089.88V302.401H1091.11V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 299.434H1093.38V302.401H1094.61V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 304.9H1089.88V307.867H1091.11V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 304.9H1093.38V307.867H1094.61V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 310.367H1089.88V313.335H1091.11V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 310.367H1093.38V313.335H1094.61V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 315.834H1089.88V318.802H1091.11V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 315.834H1093.38V318.802H1094.61V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 321.3H1089.88V324.268H1091.11V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 321.3H1093.38V324.268H1094.61V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 326.768H1089.88V329.737H1091.11V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 326.768H1093.38V329.737H1094.61V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 332.234H1089.88V335.201H1091.11V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 332.234H1093.38V335.201H1094.61V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11 337.701H1089.88V340.668H1091.11V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.61 337.701H1093.38V340.668H1094.61V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.61 326.768H1098.38V329.737H1099.61V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.11 326.768H1101.89V329.737H1103.11V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.61 332.234H1098.38V335.201H1099.61V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.11 332.234H1101.89V335.201H1103.11V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.61 337.701H1098.38V340.668H1099.61V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.11 337.701H1101.89V340.668H1103.11V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.76 326.768H1105.54V329.737H1106.76V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.27 326.768H1109.04V329.737H1110.27V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.76 332.234H1105.54V335.201H1106.76V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.27 332.234H1109.04V335.201H1110.27V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.76 337.701H1105.54V340.668H1106.76V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.27 337.701H1109.04V340.668H1110.27V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 222.898H1113.87V225.866H1115.1V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 222.898H1117.37V225.866H1118.6V222.898Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 228.366H1113.87V231.334H1115.1V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 228.366H1117.37V231.334H1118.6V228.366Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 233.833H1113.87V236.8H1115.1V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 233.833H1117.37V236.8H1118.6V233.833Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 239.299H1113.87V242.266H1115.1V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 239.299H1117.37V242.266H1118.6V239.299Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 244.766H1113.87V247.734H1115.1V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 244.766H1117.37V247.734H1118.6V244.766Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 250.233H1113.87V253.201H1115.1V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 250.233H1117.37V253.201H1118.6V250.233Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 255.699H1113.87V258.667H1115.1V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 255.699H1117.37V258.667H1118.6V255.699Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 261.166H1113.87V264.133H1115.1V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 261.166H1117.37V264.133H1118.6V261.166Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 266.633H1113.87V269.602H1115.1V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 266.633H1117.37V269.602H1118.6V266.633Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 272.1H1113.87V275.068H1115.1V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 272.1H1117.37V275.068H1118.6V272.1Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 277.566H1113.87V280.534H1115.1V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 277.566H1117.37V280.534H1118.6V277.566Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 283.033H1113.87V286.002H1115.1V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 283.033H1117.37V286.002H1118.6V283.033Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 288.501H1113.87V291.467H1115.1V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 288.501H1117.37V291.467H1118.6V288.501Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 293.967H1113.87V296.935H1115.1V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 293.967H1117.37V296.935H1118.6V293.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 299.434H1113.87V302.401H1115.1V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 299.434H1117.37V302.401H1118.6V299.434Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 304.9H1113.87V307.867H1115.1V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 304.9H1117.37V307.867H1118.6V304.9Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 310.367H1113.87V313.335H1115.1V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 310.367H1117.37V313.335H1118.6V310.367Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 315.834H1113.87V318.802H1115.1V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 315.834H1117.37V318.802H1118.6V315.834Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 321.3H1113.87V324.268H1115.1V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 321.3H1117.37V324.268H1118.6V321.3Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 326.768H1113.87V329.737H1115.1V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 326.768H1117.37V329.737H1118.6V326.768Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 332.234H1113.87V335.201H1115.1V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 332.234H1117.37V335.201H1118.6V332.234Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 337.701H1113.87V340.668H1115.1V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.6 337.701H1117.37V340.668H1118.6V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.07 337.701H1124.45V359.496H1139.07V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.51 327.318H1115.62V359.496H1128.51V327.318Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.13 331.449H1119.68V334.06H1121.13V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.45 331.449H1123V334.06H1124.45V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.13 337.049H1119.68V339.656H1121.13V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.45 337.049H1123V339.656H1124.45V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.03 337.701H1069.41V359.496H1084.03V337.701Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.55 327.318H1079.66V359.496H1092.55V327.318Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.17 331.449H1083.72V334.06H1085.17V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.49 331.449H1087.04V334.06H1088.49V331.449Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.17 337.049H1083.72V339.656H1085.17V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.49 337.049H1087.04V339.656H1088.49V337.049Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.827 318.259H707.055V321.773H867.827V318.259Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.827 314.745H707.055V315.749H867.827V314.745Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.488 280.995H763.468V344.359H780.488V280.995Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.142 274.089H762.194V344.36H765.142V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.761 274.089H779.616V344.36H781.761V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.493 314.745V288.645C768.493 286.842 770.053 285.381 771.978 285.381C773.902 285.381 775.463 286.842 775.463 288.645V314.745H768.493Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.133 321.772H770.82V344.359H773.133V321.772Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.832 280.995H793.811V344.359H810.832V280.995Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.485 274.089H792.537V344.36H795.485V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.104 274.089H809.959V344.36H812.104V274.089Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.836 314.745V288.645C798.836 286.842 800.396 285.381 802.321 285.381C804.245 285.381 805.806 286.842 805.806 288.645V314.745H798.836Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.476 321.772H801.163V344.359H803.476V321.772Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.678 326.936H924.751V359.497H940.678V326.936Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.751 329.473H927.618V332.123H928.751V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.77 329.473H930.637V332.123H931.77V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.79 329.473H933.657V332.123H934.79V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.812 329.473H936.679V332.123H937.812V329.473Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.751 334.424H927.618V337.074H928.751V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.77 334.424H930.637V337.074H931.77V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.79 334.424H933.657V337.074H934.79V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.812 334.424H936.679V337.074H937.812V334.424Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.29 277.473V290.15H1456.92V313.266H1462.23V359.496H1456.92H1450.29H1445.51H1437.28H1433.03V277.473H1450.29Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.92 292.057H1436.01V294.354H1456.92V292.057Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.92 296.783H1436.01V299.082H1456.92V296.783Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.92 301.512H1436.01V303.811H1456.92V301.512Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.92 306.24H1436.01V308.537H1456.92V306.24Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.92 310.967H1436.01V313.266H1456.92V310.967Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.23 318.484H1436.01V320.783H1462.23V318.484Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.23 323.432H1436.01V325.729H1462.23V323.432Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.23 328.377H1436.01V330.676H1462.23V328.377Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.23 333.324H1436.01V335.621H1462.23V333.324Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.23 338.27H1436.01V340.569H1462.23V338.27Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.05 279.619H1440.13V281.789H1442.05V279.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.05 283.123H1440.13V285.293H1442.05V283.123Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.05 286.627H1440.13V288.797H1442.05V286.627Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.93 279.619H1436.01V281.789H1437.93V279.619Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.93 283.123H1436.01V285.293H1437.93V283.123Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.93 286.627H1436.01V288.797H1437.93V286.627Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.691 312.52H962.375V359.497H980.691V312.52Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.381 318.426H967.532V321.432H968.381V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.765 318.426H969.916V321.432H970.765V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.15 318.426H972.301V321.432H973.15V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.534 318.426H974.685V321.432H975.534V318.426Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.381 323.199H967.532V326.203H968.381V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.765 323.199H969.916V326.203H970.765V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.15 323.199H972.301V326.203H973.15V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.534 323.199H974.685V326.203H975.534V323.199Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.381 327.971H967.532V330.977H968.381V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.765 327.971H969.916V330.977H970.765V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.15 327.971H972.301V330.977H973.15V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.534 327.971H974.685V330.977H975.534V327.971Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.381 332.744H967.532V335.748H968.381V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.765 332.744H969.916V335.748H970.765V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.15 332.744H972.301V335.748H973.15V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.534 332.744H974.685V335.748H975.534V332.744Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.381 337.516H967.532V340.522H968.381V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.765 337.516H969.916V340.522H970.765V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.15 337.516H972.301V340.522H973.15V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.534 337.516H974.685V340.522H975.534V337.516Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.73 208.533V217.123H1017.97V199.012H1017.14V217.123V217.744V224.884H1017.97V217.744H1020.73V227.886H1021.29V208.533H1020.73Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.63 352.402H1014.2V220.402L1040.63 241.652L1036.63 352.402Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.63 287.998L1036.28 264.709L1018.95 276.566L1035.63 287.998Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.02 253.371L1036.37 261.645L1036.88 243.326L1020.02 253.371Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.14 227.152V252.717L1035.66 241.681L1017.14 227.152Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.14 319.152H1034.76L1034.77 318.748L1017.14 303.334V319.152Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.96 254.6L1017.14 255.088V275.326L1034.9 263.176L1017.96 254.6Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.14 277.805V300.199L1034.13 289.451L1017.14 277.805Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.85 316.078L1035.55 290.969L1018.48 301.768L1034.85 316.078Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.309 352.402H1014.2V259.875L991.058 273.697L995.309 352.402Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.46 333.787H997.877L1004.72 340.205L1011.46 333.787Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.3 335.139V348.23L1003.23 341.631L996.3 335.139Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.16 348.109V335.023L1006.23 341.619L1013.16 348.109Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.566 301.525L1013.16 310.902V286.594L1012.76 286.361L995.566 301.525Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.598 273.508L1013.16 284.242V263.35L994.598 273.508Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.068 274.973L994.136 300.039L1010.88 285.273L993.068 274.973Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.16 330.869V315.379L996.943 330.869H1013.16Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.268 303.135L995.392 329.494L1012.7 312.961L994.268 303.135Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.53 336.293V348.576L1024.45 342.385L1017.53 336.293Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.38 348.463V336.184L1027.46 342.373L1034.38 348.463Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.69 320.203H1019.1L1025.95 326.225L1032.69 320.203Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.53 321.471V333.754L1024.45 327.563L1017.53 321.471Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.46 327.553L1034.38 333.641V321.363L1027.46 327.553Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.96 328.891L1018.97 335.139L1025.95 341.045L1033.07 335.139L1025.96 328.891Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.299 320.551H832.075V359.496H858.299V320.551Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.299 322.574H832.075V324.873H858.299V322.574Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.299 327.522H832.075V329.819H858.299V327.522Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.299 332.467H832.075V334.766H858.299V332.467Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.299 337.414H832.075V339.711H858.299V337.414Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.35 173.293C1220.35 170.606 1218.02 168.428 1215.15 168.428C1214.11 168.428 1213.15 168.721 1212.34 169.213C1211.75 167.377 1210.31 165.89 1208.44 165.165C1207.49 158.677 1201.57 153.672 1194.38 153.672C1187.47 153.672 1181.72 158.29 1180.45 164.407C1176.61 164.647 1173.58 167.628 1173.58 171.279C1173.58 172.614 1173.99 173.856 1174.69 174.912H1220.03C1220.23 174.403 1220.35 173.864 1220.35 173.293Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.32 173.5C1207.32 171.858 1205.9 170.527 1204.15 170.527C1203.89 170.527 1203.65 170.563 1203.41 170.616C1203.42 170.463 1203.43 170.311 1203.43 170.156C1203.43 166.093 1199.91 162.799 1195.58 162.799C1191.24 162.799 1187.72 166.093 1187.72 170.156C1187.72 170.508 1187.75 170.852 1187.8 171.191C1187.08 171.736 1186.61 172.562 1186.61 173.5C1186.61 174.014 1186.76 174.49 1187 174.912H1206.92C1207.17 174.49 1207.32 174.014 1207.32 173.5Z",
    fill: "white",
    stroke: "#424242",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBg);
export default __webpack_public_path__ + "static/media/building-bg.3009b38f937a1dd238f4de01189649c8.svg";
export { ForwardRef as ReactComponent };